import roles from '@/utils/roles'
import manageExecutiveRoute from '@/pages/manage/executive/routes'
import manageCompanyRoute from '@/pages/manage/company/routes'
import manageAiRoute from '@/pages/manage/Ai/routes.js'
import storybook from './storybook'

export default [
    {
        path: '/',
        display: 'Dashboard',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/DashboardV2/'),
        meta: {
            layout: 'app',
            title: 'Dashboard',
        },
    },
    {
        path: '/walkthrough',
        name: 'walkthrough',
        display: 'Walkthrough',
        exact: true,
        component: () => import(/* webpackChunkName: "auth" */ './pages/WalkthroughPage.vue'),
        meta: {
            layout: 'empty',
            title: 'Walkthrough',
            anonymous: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        display: 'Login',
        exact: true,
        component: () => import(/* webpackChunkName: "auth" */ './pages/login-page'),
        meta: {
            layout: 'empty',
            title: 'Login',
            anonymous: true,
        },
    },
    {
        path: '/legal/privacy-policy',
        name: 'privacy-policy',
        display: 'Legal - Privacy Policy',
        exact: true,
        component: () => import(/* webpackChunkName: "auth" */ './pages/legal/LegalPrivacyPolicyPage.vue'),
        meta: {
            layout: 'empty',
            title: 'Privacy Policy',
            anonymous: true,
        },
    },
    {
        path: '/legal/terms',
        name: 'legal',
        display: 'Legal',
        exact: true,
        component: () => import(/* webpackChunkName: "auth" */ './pages/legal/LegalTermsPage.vue'),
        meta: {
            layout: 'empty',
            title: 'Legal Terms',
            anonymous: true,
        },
    },
    {
        path: '/account/recover',
        exact: true,
        component: () => import(/*webpackChunkName: "auth" */ './pages/account/recovery-begin-page'),
        meta: {
            layout: 'auth',
            title: 'Login',
            anonymous: true,
        },
    },
    {
        path: '/account/recover/:token',
        props: true,
        component: () => import(/*webpackChunkName: "auth" */ './pages/account/recovery-finish-page'),
        meta: {
            layout: 'auth',
            title: 'Login',
            anonymous: true,
        },
    },
    {
        path: '/account/activate/:token',
        props: true,
        component: () => import(/*webpackChunkName: "auth" */ './pages/account/recovery-finish-page'),
        meta: {
            layout: 'auth',
            title: 'Activate Your Account',
            anonymous: true,
        },
    },
    {
        path: '/premium-research-reports',
        name: 'premium-research-page',
        display: 'Premium Research',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/Research/ResearchIndex.vue'),
        meta: {
            layout: 'app',
            title: 'Premium Research',
        },
    },
    {
        path: '/ceo-change-reports',
        redirect: '/premium-research-reports',
    },
    {
        path: '/ceo-change-calendar',
        name: 'ceo-change-calendar',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/CeoChangeCalendar/CeoChangeCalendarPage.vue'),
        meta: {
            layout: 'app',
            title: 'CEO Change Calendar',
            roles: [roles.read],
        },
    },
    {
        path: '/outlier-insider-transactions',
        name: 'outlier-insider-transactions',
        exact: true,
        component: () =>
            import(
                /* webpackChunkName: "main" */ './pages/OutlierInsiderTransactionsPage/OutlierInsiderTransactionsPage.vue'
            ),
        meta: {
            layout: 'app',
            title: 'Outlier Insider Transactions',
            roles: [roles.read],
        },
    },
    {
        path: '/executives',
        display: 'Executives',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/executives-page/'),
        meta: {
            layout: 'app',
            title: 'Executives',
            roles: [roles.read],
        },
    },
    {
        path: '/executives/:id',
        display: 'Executives',
        name: 'executive-page',
        props: route => ({
            id: parseInt(route.params.id),
        }),
        component: () => import(/* webpackChunkName: "main" */ './pages/ExecutivePage/'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/sec/filings/:accessionNumber',
        display: 'SEC Filing',
        name: 'sec-filing',
        props: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/Sec/Filing.vue'),
        meta: {
            layout: 'empty',
        },
    },
    {
        path: '/companies',
        display: 'Companies',
        name: 'companies-page',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/CompaniesPage'),
        meta: {
            layout: 'app',
            title: 'Companies',
            roles: [roles.read],
        },
    },
    {
        path: '/companies/:id',
        display: 'Company',
        name: 'company-page',
        props: route => ({
            id: parseInt(route.params.id),
        }),
        component: () => import(/* webpackChunkName: "main" */ './pages/CompanyPage/'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/evasion',
        display: 'Evasion',
        name: 'evasion-page',
        exact: true,
        component: () => import(/* webpackChunkName: "main" */ './pages/EvasionPage/EvasionPage.vue'),
        meta: {
            layout: 'app',
            title: 'Evasion',
            roles: [roles.read],
        },
    },
    {
        path: '/audit-risk/legend',
        display: 'F.L.A.G. Risk Legend',
        props: false,
        component: () => import(/* webpackChunkName: "main" */ './pages/AuditRiskLegend'),
        meta: {
            layout: 'empty',
        },
    },
    {
        path: '/watchlist',
        redirect: '/tracklist',
    },
    {
        path: '/tracklist',
        display: 'TrackList',
        component: () => import(/* webpackChunkName: "main" */ './pages/TrackListPage'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/my-custom-work/:slug?',
        name: 'my-custom-work',
        display: 'Custom Work',
        component: () => import(/* webpackChunkName: "custom-work" */ './pages/CustomWork/'),
        props: true,
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/organization',
        display: 'Organization',
        exact: true,
        component: () => import(/* webpackChunkName: "account" */ './pages/organization-page'),
        meta: {
            layout: 'app',
            title: 'Organization',
            roles: [roles.manageOrganization, roles.salesAdmin],
        },
    },
    {
        path: '/organization/users/:id',
        display: 'Organizations',
        props: true,
        component: () => import(/* webpackChunkName: "account" */ './pages/organization-user-page'),
        meta: {
            layout: 'app',
            title: 'Organization',
            roles: [roles.manageOrganization, roles.salesAdmin],
        },
    },
    {
        path: '/account',
        display: 'Account',
        exact: true,
        component: () => import(/* webpackChunkName: "account" */ './pages/account/AccountPage/AccountPage.vue'),
        meta: {
            layout: 'app',
            title: 'Account',
        },
    },

    // Client management
    {
        name: 'admin-client-management',
        path: '/admin/clients',
        props: true,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/ClientManagementPage'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        name: 'admin-client-management-organization',
        path: '/admin/clients/organizations/:id',
        props: route => ({
            selectedOrganizationId: parseInt(route.params.id),
            selectedUserId: null,
        }),
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/ClientManagementPage'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        name: 'admin-client-management-user',
        path: '/admin/clients/users/:id',
        props: route => ({
            selectedOrganizationId: null,
            selectedUserId: parseInt(route.params.id),
        }),
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/ClientManagementPage'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },

    {
        path: '/admin/organizations',
        props: true,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/organizations-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        path: '/admin/organizations/:id',
        props: true,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/OrganizationPage/OrganizationPage.vue'),
        name: 'admin-organization-page',
        meta: {
            layout: 'app',
            title: 'Organizations',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        path: '/admin/users',
        props: true,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/users-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        path: '/admin/users/:id',
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/UserPage/'),
        name: 'admin-user-page',
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
        props: route => ({
            id: parseInt(route.params.id),
        }),
    },
    {
        path: '/admin/logins',
        props: true,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/logins-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.internalRead],
        },
    },
    manageAiRoute,
    manageCompanyRoute,
    manageExecutiveRoute,
    {
        path: '/manage/research',
        display: 'Manage Research',
        name: 'manage-research-page',
        component: () => import(/* webpackChunkName: "manage-research" */ './pages/manage/Research'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.research, roles.salesAdmin],
        },
    },
    {
        path: '/manage/research/:reportId/survey',
        display: 'Manage Research',
        name: 'manage-research-survey-svg',
        component: () => import(/* webpackChunkName: "manage-research" */ './pages/manage/Research/SurveysSvgPage.vue'),
        props: route => ({ reportId: parseInt(route.params.reportId) }),
        meta: {
            layout: 'empty',
            roles: [roles.admin, roles.research, roles.salesAdmin, roles.dataEntryInterviewSurveys],
        },
    },
    {
        name: 'manage-research-ceo-calendar-notifications-send',
        path: '/manage/research/ceo-calendar-notifications',
        component: () =>
            import(
                /* webpackChunkName: "manage-research" */ './pages/manage/Research/CeoCalendar/CeoCalendarNotificationSendPage.vue'
            ),
        meta: {
            layout: 'app',
            roles: [roles, roles.research],
        },
    },
    {
        path: '/manage/custom-work/:id',
        display: 'Manage Custom Work',
        name: 'manage-custom-work',
        component: () => import(/* webpackChunkName: "manage-research" */ './pages/manage/CustomWork'),
        props: route => ({ id: parseInt(route.params.id) }),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.research, roles.salesAdmin],
        },
    },

    {
        path: '/manage/providers/:providerId/executives/:providerEntityId',
        display: 'Provider Executive',
        props: true,
        component: () => import(/* webpackChunkName: "manage" */ './pages/manage/provider-executive-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.matching, roles.inHouseDataEntry],
        },
    },
    {
        path: '/manage/providers/sec/ownership/filings',
        display: 'Manage SEC Ownership Filings',
        name: 'manage-providers-sec-ownership-filings',
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "manage" */ './pages/manage/providers/sec/ownership/filings/SecOwnershipFilingsPage.vue'
            ),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.matching, roles.inHouseDataEntry, roles.internalRead],
        },
    },
    {
        path: '/manage/providers/sec/ownership/filings/:accessionNumber',
        display: 'Manage SEC Ownership Filing',
        name: 'manage-providers-sec-ownership-filing',
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "manage" */ './pages/manage/providers/sec/ownership/filings/SecOwnershipFilingPage.vue'
            ),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.matching, roles.inHouseDataEntry, roles.internalRead],
        },
    },
    {
        path: '/manage/providers/sec/filers/',
        display: 'Manage SEC Ownership Filers',
        name: 'manage-providers-sec-filers',
        props: true,
        component: () =>
            import(/* webpackChunkName: "manage" */ './pages/manage/providers/sec/filers/SecFilersPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.matching, roles.inHouseDataEntry, roles.internalRead],
        },
    },
    {
        path: '/manage/providers/sec/filers/:cik',
        display: 'Manage SEC Ownership Filer',
        name: 'manage-providers-sec-filer',
        props: true,
        component: () =>
            import(/* webpackChunkName: "manage" */ './pages/manage/providers/sec/filers/SecFilerPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.matching, roles.inHouseDataEntry, roles.internalRead],
        },
    },
    {
        path: '/manage/transcripts/topics',
        redirect: '/manage/ai/transcripts/topics',
    },
    {
        path: '/admin/reports',
        display: 'Reports',
        props: false,
        component: () => import(/* webpackChunkName: "admin" */ './pages/admin/reports/AdminReportsPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.salesAdmin],
        },
    },
    {
        path: '/admin/manage/reports/',
        display: 'Manage Reports',
        name: 'admin-manage-reports',
        props: false,
        component: () =>
            import(/* webpackChunkName: "admin" */ './pages/admin/manage/reports/AdminManageReportsListPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin],
        },
    },
    {
        path: '/admin/manage/reports/add',
        display: 'Manage Reports',
        name: 'admin-manage-reports-add',
        props: false,
        component: () =>
            import(/* webpackChunkName: "admin" */ './pages/admin/manage/reports/AdminManageReportsAddPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin],
        },
    },
    {
        path: '/admin/manage/reports/:id',
        display: 'Manage Reports',
        name: 'admin-manage-reports-edit',
        props: route => ({
            id: parseInt(route.params.id),
        }),
        component: () =>
            import(/* webpackChunkName: "admin" */ './pages/admin/manage/reports/AdminManageReportsEditPage.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin],
        },
    },
    {
        path: '/manage',
        display: 'Manage',
        props: false,
        component: () => import(/* webpackChunkName: "manage" */ './pages/manage/dashboard/ManageDashboard.vue'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.dataEntry, roles.matching, roles.inHouseDataEntry, roles.research],
        },
    },
    {
        path: '/manage/tools/:tool?',
        display: 'Tools',
        name: 'manage-tools',
        props: true,
        component: () => import(/* webpackChunkName: "manage" */ './pages/manage/Tools/'),
        meta: {
            layout: 'app',
            roles: [roles.admin, roles.interviewers, roles.research, roles.salesAdmin],
        },
    },
    {
        path: '/debug/notifications',
        display: 'Debug TrackList Notifications',
        component: () => import(/* webpackChunkName: "debug" */ './pages/debug/notifications-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin],
        },
    },
    {
        path: '/debug/emails',
        display: 'Debug Emails',
        name: 'debug-emails',
        component: () => import(/* webpackChunkName: "debug" */ './pages/debug/emails-page'),
        meta: {
            layout: 'app',
            roles: [roles.admin],
        },
    },
    storybook,
]
